<template>
  <asc-dialog
    :show-dialog="showDialog"
    :text="getDialogTitle"
    :on-close="handleClose"
    :width="1000"
  >
    <template v-if="showDialog">
      <asc-flight-deck-effects
        :items="items"
        :fde-item="fdeItem"
        :grid-columns="gridColumns"
        :on-open-full-fleet="handleOpenFullFleet"
        :loading="loading"
      ></asc-flight-deck-effects>
    </template>
  </asc-dialog>
</template>

<script>
import { AscDialogMixin } from '@/components/mixins'
import AscDialog from '@/components/atoms/AscDialog'
import AscFlightDeckEffects from './AscFlightDeckEffects'

export default {
  name: 'AscFlightDectEffectsDialog',

  components: {
    AscDialog,
    AscFlightDeckEffects,
  },

  mixins: [AscDialogMixin],

  props: {
    items: {
      type: Array,
      default: () => [],
    },
    fdeItem: {
      type: Object,
      default: () => {},
    },
    gridColumns: {
      type: Array,
      default: () => [],
    },
    onOpenFullFleet: {
      type: Function,
      default: () => {},
    },
  },

  computed: {
    getDialogTitle() {
      return this.fdeItem?.name
        ? `Flight Deck Effects for ${this.fdeItem.name}`
        : ''
    },
  },

  methods: {
    handleOpenFullFleet() {
      this.onClose()
      if (this.onOpenFullFleet) {
        this.onOpenFullFleet()
      }
    },
  },
}
</script>
